import angular from 'angular';
import secureFileUploaderStepIndicatorComponent from './secureFileUploaderStepIndicator.component';

let secureFileUploaderStepIndicatorModule = angular.module('secureFileUploaderStepIndicator', []).component('secureFileUploaderStepIndicator', secureFileUploaderStepIndicatorComponent);

export default secureFileUploaderStepIndicatorModule;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderStepIndicator/secureFileUploaderStepIndicator.js